import { createAction } from '@reduxjs/toolkit';

import { IListResponse } from 'interfaces/common';
import { IProfile } from 'interfaces/user.interfaces';
import { ICustomerPhone, IPatientView } from 'interfaces/patients.interfaces';
import {
  ISignIn,
  ISignInResponse,
  IResetPassword,
  IResendCode,
  INHSLoginUrlRequest,
  INHSLoginUrlResponse,
  ISignInNHS,
} from '../interfaces/auth.interfaces';
import { IChallenge } from '../interfaces/challenge.interfaces';
import { IExchangeToken, IToken } from '../interfaces/token.interfaces';

// Sign In
export const signIn = createAction<ISignIn>('SIGN_IN_REQUEST');
export const signInSuccess = createAction<IToken[]>('SIGN_IN_SUCCESS');
export const signInError = createAction<string>('SIGN_IN_ERROR');

// Refresh
export const refreshTokenSuccess = createAction<ISignInResponse>('REFRESH_TOKEN_SUCCESS');

// Exchange token
export const exchangeToken = createAction<IExchangeToken>('EXCHANGE_TOKEN_REQUEST');
export const exchangeTokenSuccess = createAction<ISignInResponse>('EXCHANGE_TOKEN_SUCCESS');
export const exchangeTokenError = createAction<string>('EXCHANGE_TOKEN_ERROR');

// Sign In NHS
export const signInNHS = createAction<ISignInNHS>('SIGN_IN_NHS_REQUEST');
export const signInNHSSuccess = createAction<ISignInResponse>('SIGN_IN_NHS_SUCCESS');
export const signInNHSError = createAction<string>('SIGN_IN_NHS_ERROR');

export const getNHSLoginUrl = createAction<INHSLoginUrlRequest>('GET_NHS_LOGIN_URL');
export const getNHSLoginUrlSuccess = createAction<INHSLoginUrlResponse>(
  'GET_NHS_LOGIN_URL_SUCCESS',
);
export const getNHSLoginUrlError = createAction<string>('GET_NHS_LOGIN_URL_ERROR');

// Challenge
export const challenge = createAction<{
  values: IChallenge;
  setError: (message: string) => void;
  isMfaSetup?: boolean;
}>('CHALLENGE_REQUEST');
export const challengeSuccess = createAction('CHALLENGE_SUCCESS');
export const challengeError = createAction<string>('CHALLENGE_ERROR');

// Reset Password
export const resetPassword = createAction<IResetPassword>('RESET_PASSWORD_REQUEST');
export const resetPasswordSuccess = createAction<ISignInResponse>('RESET_PASSWORD_SUCCESS');
export const resetPasswordError = createAction<string>('RESET_PASSWORD_ERROR');

// Unlock App
export const unblockApp = createAction<{
  values: { password: string };
  setError: (message: string) => void;
}>('UNLOCK_APP_REQUEST');
export const unblockAppSuccess = createAction('UNLOCK_APP_SUCCESS');
export const unblockAppError = createAction<string>('UNLOCK_APP_ERROR');

// Save Authenticate info
export const changeAuthenticated = createAction<boolean>('CHANGE_AUTHENTICATED');

// Session Timeout Block
export const changeSessionTimeoutBlock = createAction<boolean>('CHANGE_SESSION_TIMEOUT_BLOCK');

// Ping activity in pharmacy
export const pingActivity = createAction<{ successFunc: () => void; errorFunc: () => void }>(
  'PING_ACTIVITY',
);

// Customer
export const getProfiles = createAction('GET_PROFILES');
export const getProfilesSuccess = createAction<IListResponse<IProfile>>('GET_PROFILES_SUCCESS');
export const getProfilesError = createAction<string>('GET_PROFILES_ERROR');

export const patchCustomer = createAction<{
  data: Partial<IPatientView>;
  phone?: Partial<ICustomerPhone>;
  onSuccess?: () => void;
}>('PATCH_CUSTOMER');
export const patchCustomerSuccess = createAction<IPatientView>('PATCH_CUSTOMER_SUCCESS');
export const patchCustomerError = createAction<string>('PATCH_CUSTOMER_ERROR');

// Sign Out
export const signOut = createAction<{ route?: string } | undefined>('SIGN_OUT');
export const signOutSuccess = createAction('SIGN_OUT_SUCCESS');
export const signOutError = createAction('SIGN_OUT_ERROR');

export const signOutPatient = createAction('SIGN_OUT_PATIENT');

// Resend Code
export const resendCode = createAction<IResendCode>('RESEND_CODE_REQUEST');
export const resendCodeSuccess = createAction('RESEND_CODE_SUCCESS');
export const resendCodeError = createAction<string>('RESEND_CODE_ERROR');
